import { z } from "zod";
import { ZodStringNullable } from "../zod-types/zod-string-nullable";

export const wikiPageSchema = z.object({
	// Present, and allowed to be empty. A page whose content is a video and nothing else is the
	// ordinary case for a recording — and demanding text first put a paragraph between the author
	// and the record button, since the recorder refuses a page the server would not accept. The
	// column is `text().default("").notNull()`, so the empty string is a value it already stores.
	content: z.string(),
	title: z.string().min(1, "Title is required"),
	spaceId: z.string(),
	parentPageId: ZodStringNullable,
});

export type WikiPageSchema = z.infer<typeof wikiPageSchema>;
